import "./_wizard-steps.scss";

/**
 * Moved from _features/proposals/components/ProposalWizardSteps.jsx and
 * generalized to take `steps` as a prop (was hardcoded to
 * PROPOSAL_WIZARD_STEPS) - the subscription modal's 2-step wizard uses the
 * same progress-pip UI, so this lives at the shared root instead of being
 * re-built per feature. Renders either inline (modal host) or handed to
 * PageHeaderBar's `centerComponent` slot (routed page hosts) - same
 * component, two different places in the DOM, per host.
 *
 * `onStepClick` is opt-in (only Proposals' hosts pass it, per the Liquid
 * Glass design's own step "tabs" - each step is a clickable button, not
 * just a progress indicator). Omitted, every other caller keeps today's
 * inert `<div>` behavior unchanged. Only done/active steps are clickable
 * even when a handler is passed - jumping to a not-yet-reached step would
 * skip whatever validation `goToNextStep` normally gates on, so the caller
 * only reaches an ahead-of-currentStep id by advancing through Next.
 */
const WizardSteps = ({ steps, currentStep, className = "", onStepClick }) => (
  <div className={`wizard-steps ${className}`.trim()}>
    {steps.map((step, idx) => {
      const isActive = step.id === currentStep;
      const isDone = step.id < currentStep;
      const isClickable = Boolean(onStepClick) && (isActive || isDone);
      const Tag = isClickable ? "button" : "div";

      return (
        <div className="wizard-steps__item" key={step.id}>
          {idx > 0 && <span className="wizard-steps__connector" aria-hidden="true" />}
          <Tag
            type={isClickable ? "button" : undefined}
            className={`wizard-steps__step ${isActive ? "wizard-steps__step--active" : ""} ${
              isDone ? "wizard-steps__step--done" : ""
            } ${isClickable ? "wizard-steps__step--clickable" : ""}`}
            onClick={isClickable ? () => onStepClick(step.id) : undefined}
          >
            <span className="wizard-steps__index">{step.id}</span>
            <span className="wizard-steps__label">{step.label}</span>
          </Tag>
        </div>
      );
    })}
  </div>
);

export default WizardSteps;
